import { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { createAppKit } from "@reown/appkit/react";
import { EthersAdapter } from "@reown/appkit-adapter-ethers";
import { base, bsc, mainnet } from "@reown/appkit/networks";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import RoutesFile from "./RoutesFile";
import "./App.css";
import { BASE_URL } from "./contracts/aggregatorV3ABI";

// 1. Get projectId
const projectId = "dc835ecaaa41287eb59a75fd08e11d48";

// 2. Set the networks
const networks = [mainnet, bsc, base];

// 3. Metadata (optional)
const metadata = {
  name: "Baby Unicorn AI",
  description: "Presale website powered by Baby Unicorn AI",
  url: "https://babyu.tech/", // must match origin
  icons: [`${BASE_URL}/logo.png`],
};

// 4. Create AppKit config
export const config = createAppKit({
  adapters: [new EthersAdapter()],
  networks,
  metadata,
  projectId,
  features: {
    analytics: true,
    email: false,
    socials: false,
  },
});

// ✅ Stripe initialized with your publishable key
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
console.log("Stripe key:", process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
console.log("google key:", process.env.REACT_APP_GOOGLE_CLIENT_ID);

function App() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth < 640); // tailwind sm breakpoint
    };
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      {/* ✅ Wrap entire app in Stripe Elements provider */}
      <Elements stripe={stripePromise}>
        <RoutesFile />
        <Toaster
          position={isMobile ? "top-center" : "top-right"}
          reverseOrder={false}
          toastOptions={{
            className: "frame-11g",
            style: {
              background: "#1e1e1e",
              color: "#ffffff",
              borderRadius: "8px",
            },
          }}
        />
      </Elements>
    </GoogleOAuthProvider>
  );
}

export default App;
